import React from "react";
import { motion, Variants } from "framer-motion";
import { t } from "../../i18n";
const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

/* // _ işaretleri arasındaki metinleri bold yapan yardımcı fonksiyon
const formatTextWithBold = (text: string) => {
  const parts = text.split(/(_[^_]+_)/);
  return parts.map((part, index) => {
    if (part.startsWith("_") && part.endsWith("_")) {
      // _ işaretleri arasındaki metni bold yap
      return <strong key={index}>{part.slice(1, -1)}</strong>;
    }
    return part;
  });
}; */

const PlatformVisualSection: React.FC = () => {
  return (
    <section className="py-16 px-6 md:px-12 xl:px-20">
      <motion.div
        className="max-w-8xl mx-auto flex flex-col-reverse md:flex-row items-center gap-12 md:gap-24 mt-16 md:mt-20 bg-[#edf2f4] p-6 md:p-12 rounded-2xl"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInUp}
      >
        <motion.div className="w-full md:w-3/5" variants={fadeInUp}>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-primaryGreen to-primaryPurple-light text-transparent bg-clip-text leading-snug">
            {t("platformVisualSection.title")}
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-8 mb-6 text-justify">{t("platformVisualSection.description")}</p>

          <div className="flex flex-col gap-y-6 max-w-full overflow-x-auto">
            <ul className="list-disc pl-5 text-base md:text-lg text-gray-700 space-y-2">
              <li className="list-none">
                <strong>{t("platformVisualSection.title1")}</strong>
              </li>
              <li className="text-justify">{t("platformVisualSection.text1")}</li>
              <li className="text-justify">{t("platformVisualSection.text2")}</li>
              <li className="text-justify">{t("platformVisualSection.text3")}</li>
            </ul>

            <ul className="list-disc pl-5 text-base md:text-lg text-gray-700 space-y-2">
              <li className="list-none">
                <strong>{t("platformVisualSection.title2")}</strong>
              </li>
              <li className="text-justify">{t("platformVisualSection.text4")}</li>
              <li className="text-justify">{t("platformVisualSection.text5")}</li>
              <li className="text-justify">{t("platformVisualSection.text6")}</li>
            </ul>

            <ul className="list-disc pl-5 text-base md:text-lg text-gray-700 space-y-2">
              <li className="list-none">
                <strong>{t("platformVisualSection.title3")}</strong>
              </li>
              <li className="text-justify">{t("platformVisualSection.text7")}</li>
              <li className="text-justify">{t("platformVisualSection.text8")}</li>
              <li className="text-justify">{t("platformVisualSection.text9")}</li>
            </ul>
          </div>
        </motion.div>

        <motion.div className="w-full md:w-2/5" variants={fadeInUp}>
          <div className="relative w-full h-[370px] mb-10 ">
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl"
              src="https://www.youtube.com/embed/Ojhb6q0TbHs"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default PlatformVisualSection;
